// extracted by mini-css-extract-plugin
export default {"section":"Section_section__EhZJN","inactive":"Section_inactive__1qJU3","content":"Section_content__sIiqb","active":"Section_active__pb5Q2"};